import { Modal } from 'antd';
import React from 'react';
import './index.scss';

import Buttons from 'components/Global/Buttons';

type ConfirmModalProps = {
	visible: boolean;
	onOk: () => void;
	onCancel: () => void;
	content?: string;
	okText?: string;
	cancelText?: string;
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	visible,
	onOk,
	onCancel,
	content = '',
	okText = 'Yes',
	cancelText = 'Cancel',
}) => {
	const myButtons = [
		{
			text: 'Cancel',
			isLoading: false,
			className: 'secondary-button',
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			disabled: false,
			isSubmit: false,
			onclick: () => {
				onCancel();
			},
		},
		{
			text: 'Save',
			isLoading: false,
			className: 'btn-blue',
			fontSize: '1.8rem',
			minWidth: '12rem',
			minHeight: '4rem',
			disabled: false,
			isSubmit: true,
			onclick: () => {
				onOk();
			},
		},
	];
	return (
		<Modal
			className="confirm-modal"
			open={visible}
			onOk={onOk}
			closable={false}
			maskClosable={false}
			onCancel={onCancel}
			okText={okText}
			cancelText={cancelText}
			footer={
				<div className="modal-buttons">
					<Buttons buttons={myButtons} />
				</div>
			}
		>
			<div className="modal-content">
				<p>{content}</p>
			</div>
		</Modal>
	);
};

export default ConfirmModal;
